const supportedExtensions = new Set([
    // --- WSI FORMATS ---
    '.svs',
    '.tif',
    '.tiff',
    '.ndpi',
    '.vms',
    '.vmu',
    '.scn',
    '.mrxs',
    '.bif',
    '.czi',
    '.avs',
    '.svslide',
    '.dcm',
    '.dicom',
    '.isyntax',
    '.qptiff',
    '.vsi',
    '.zvi',
    '.afi',

    // --- METADATA & CLINICAL DOCUMENTS ---
    '.txt',
    '.pdf',
    '.csv',
    '.xml',
    '.json',
    '.md',
    '.xlsx',
    '.xls',
    '.doc',
    '.docx',
    '.hl7',
    '.yaml',
    '.yml',

    // --- ARCHIVES ---
    '.zip',
    '.tar',
    '.gz'
])

export default supportedExtensions